module.exports = "<div class=\"col-sm-7 lds-circle\"><div></div></div>\r\n"